<div *ngIf="compositionslist | async as compo">
    <div *ngIf="compo.length>0">
    	{{compo.length}}
    </div>
</div>